import React from "react";
import { useLocation, Navigate, Link } from "react-router-dom";
import SEO from "@/components/SEO";
import { STATIC_PAGES } from "@/data/staticPages";
import { Mail, ChevronRight } from "lucide-react";

export default function StaticPage() {
  const location = useLocation();
  const slug = location.pathname.replace(/^\/+/, "");
  const page = STATIC_PAGES[slug];
  if (!page) return <Navigate to="/" replace />;

  return (
    <div data-testid={`static-page-${slug}`}>
      <SEO
        title={page.seoTitle || page.title}
        description={page.description}
        canonical={`/${slug}`}
      />
      <div className="bg-gradient-to-br from-primary/5 via-background to-accent/5 py-14 border-b border-border">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="flex items-center gap-1 text-xs text-muted-foreground mb-4">
            <Link to="/" className="hover:text-primary">Ana Sayfa</Link>
            <ChevronRight className="h-3 w-3" />
            <span className="text-foreground">{page.title}</span>
          </nav>
          <h1 className="font-display text-4xl md:text-5xl font-bold tracking-tight">{page.title}</h1>
          {page.hero && <p className="mt-4 text-lg text-muted-foreground max-w-2xl">{page.hero}</p>}
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-10">
        {page.sections.map((s, i) => (
          <section key={i}>
            <h2 className="font-display text-2xl font-bold mb-3">{s.h}</h2>
            <p className="text-base leading-relaxed text-muted-foreground">{s.p}</p>
          </section>
        ))}

        <div className="mt-16 p-6 rounded-xl border border-border bg-card flex items-center justify-between gap-4 flex-wrap">
          <div>
            <div className="font-display font-bold">Sorunuz mu var?</div>
            <div className="text-sm text-muted-foreground">Ekibimiz 1 iş günü içinde yanıtlar.</div>
          </div>
          <a href="mailto:destek@sanostudent.com" className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-primary text-primary-foreground text-sm font-medium" data-testid="static-contact-cta">
            <Mail className="h-4 w-4" /> destek@sanostudent.com
          </a>
        </div>
      </div>
    </div>
  );
}
